import React from 'react';
import { Route } from 'react-router-dom';

// attendance

// 학생 출결 목록
const ARListOwnedByTeacher = React.lazy(
  () => import('pages/teacherSide/attendance/ARListOwnedByTeacher/ARListOwnedByTeacher'),
);

const ARListOfToday = React.lazy(
  () => import('pages/teacherSide/attendance/ARListOfToday/ARListOfToday'),
);

const ARListByDate = React.lazy(
  () => import('pages/teacherSide/attendance/ARListByDate/ARListByDate'),
);

const ARListOfAllStudents = React.lazy(
  () => import('pages/teacherSide/attendance/ARListOfAllStudents/ARListOfAllStudents'),
);

const AttWeeklyInfo = React.lazy(
  () => import('pages/teacherSide/attendance/AttWeeklyInfo/AttWeeklyInfo'),
);

const AttScheduleByDate = React.lazy(
  () => import('pages/teacherSide/attendance/AttScheduleByDate/AttScheduleByDate'),
);

const AttRealtime = React.lazy(
  () => import('pages/teacherSide/attendance/AttRealtime/AttRealtime'),
);

// 새 출결 기록
const NullComponent = () => null;

const WriteAttRecord = React.lazy(
  () =>
    new Promise((resolve) => {
      resolve({ default: NullComponent as never });
    }),
);

// 교사 근태 관리
const AttRecordListOfTeacher = React.lazy(
  () => import('pages/teacherSide/attendance/AttRecordListOfTeacher/AttRecordListOfTeacher'),
);
const AttRecordListOfAllTeachers = React.lazy(
  () =>
    import('pages/teacherSide/attendance/AttRecordListOfAllTeachers/AttRecordListOfAllTeachers'),
);

// homework and schedule
const HomeworkList = React.lazy(
  () => import('pages/teacherSide/homework/HomeworkList/HomeworkList'),
);
const HomeworkSearch = React.lazy(
  () => import('pages/teacherSide/homework/HomeworkSearch/HomeworkSearch'),
);
const HomeworkPresetAdd = React.lazy(
  () => import('pages/teacherSide/homework/HomeworkPresetAdd/HomeworkPresetAdd'),
);

// report
const LessonReportTemplateList = React.lazy(
  () => import('pages/teacherSide/lessonReport/LessonReportTemplateList/LessonReportTemplateList'),
);
const LessonReportTemplateAdd = React.lazy(
  () => import('pages/teacherSide/lessonReport/LessonReportTemplateAdd/LessonReportTemplateAdd'),
);
const LessonReportGroupAdd = React.lazy(
  () => import('pages/teacherSide/lessonReport/LessonReportGroupAdd/LessonReportGroupAdd'),
);
const LessonReportGroupList = React.lazy(
  () => import('pages/teacherSide/lessonReport/LessonReportGroupList/LessonReportGroupList'),
);
const LessonReportGroupWrite = React.lazy(
  () => import('pages/teacherSide/lessonReport/LessonReportGroupWrite/LessonReportGroupWrite'),
);
const ExamTemplateList = React.lazy(
  () => import('pages/teacherSide/exam/ExamTemplateList/ExamTemplateList'),
);
const ExamTemplateAdd = React.lazy(
  () => import('pages/teacherSide/exam/ExamTemplateAdd/ExamTemplateAdd'),
);
const ExamGroupAdd = React.lazy(() => import('pages/teacherSide/exam/ExamGroupAdd/ExamGroupAdd'));
const ExamGroupList = React.lazy(
  () => import('pages/teacherSide/exam/ExamGroupList/ExamGroupList'),
);
const ExamGroupWrite = React.lazy(
  () => import('pages/teacherSide/exam/ExamGroupWrite/ExamGroupWrite'),
);
const SimpleExam = React.lazy(() => import('pages/teacherSide/exam/SimpleExam/SimpleExam'));
const AnalysisReportGenerate = React.lazy(
  () => import('pages/teacherSide/analysisReport/AnalysisReportGenerate/AnalysisReportGenerate'),
);

// 상담 관련
const CounselLog = React.lazy(() => import('pages/teacherSide/counsel/CounselLog/CounselLog'));

const CounselLogCount = React.lazy(
  () => import('pages/teacherSide/counsel/CounselLogCount/CounselLogCount'),
);

// message
const MessageSend = React.lazy(() => import('pages/teacherSide/message/MessageSend/MessageSend'));
const MessageHistory = React.lazy(
  () => import('pages/teacherSide/message/MessageHistory/MessageHistory'),
);

// setting
const SettingBillingPlan = React.lazy(
  () => import('pages/teacherSide/setting/SettingBillingPlan/SettingBillingPlan'),
);
const SettingBillingFeatureStatus = React.lazy(
  () => import('pages/teacherSide/setting/SettingBillingFeatureStatus/SettingBillingFeatureStatus'),
);
const SettingBillingTrialApply = React.lazy(
  () => import('pages/teacherSide/setting/SettingBillingTrialApply/SettingBillingTrialApply'),
);
const SettingBillingPlusApply = React.lazy(
  () => import('pages/teacherSide/setting/SettingBillingPlusApply/SettingBillingPlusApply'),
);
const SettingBillingPlusEnd = React.lazy(
  () => import('pages/teacherSide/setting/SettingBillingPlusEnd/SettingBillingPlusEnd'),
);
const SettingBillingInfoEdit = React.lazy(
  () => import('pages/teacherSide/setting/SettingBillingInfoEdit/SettingBillingInfoEdit'),
);
const SettingAttendance = React.lazy(
  () => import('pages/teacherSide/setting/SettingAttendance/SettingAttendance'),
);
const SettingAcademyManagement = React.lazy(
  () => import('pages/teacherSide/setting/SettingAcademyManagement/SettingAcademyManagement'),
);
const SettingAcademyInfo = React.lazy(
  () => import('pages/teacherSide/setting/SettingAcademyInfo/SettingAcademyInfo'),
);
const SettingBill = React.lazy(() => import('pages/teacherSide/setting/SettingBill/SettingBill'));
const SettingContentPoint = React.lazy(() => import('pages/teacherSide/setting/SettingContentPoint/SettingContentPoint'));
const SettingMessage = React.lazy(
  () => import('pages/teacherSide/setting/SettingMessage/SettingMessage'),
);
const SettingPost = React.lazy(() => import('pages/teacherSide/setting/SettingPost/SettingPost'));
const SettingChat = React.lazy(() => import('pages/teacherSide/setting/SettingChat/SettingChat'));
const SettingHomework = React.lazy(
  () => import('pages/teacherSide/setting/SettingHomework/SettingHomework'),
);
const SettingTextbook = React.lazy(
  () => import('pages/teacherSide/setting/SettingTextbook/SettingTextbook'),
);
//
// 4) 교사화면 탭
//

const RouteListTeacherSide = (
  <Route path="/teacherSide/">
    <Route path="attendance/">
      <Route path="student/list" element={<ARListOwnedByTeacher />} />
      <Route path="student/ofToday" element={<ARListOfToday />} />
      <Route path="student/byDate" element={<ARListByDate />} />
      <Route path="student/all" element={<ARListOfAllStudents />} />
      <Route path="student/weeklyInfo" element={<AttWeeklyInfo />} />
      <Route path="student/scheduleByDate" element={<AttScheduleByDate />} />
      <Route path="student/realtime" element={<AttRealtime />} />
      <Route path="writeAttRecord" element={<WriteAttRecord />} />
      <Route path="teacher/list" element={<AttRecordListOfTeacher />} />
      <Route path="teacher/all" element={<AttRecordListOfAllTeachers />} />
    </Route>
    <Route path="homework/">
      <Route path="list" element={<HomeworkList />} />
      <Route path="search" element={<HomeworkSearch />} />
      <Route path="preset/add" element={<HomeworkPresetAdd />} />
    </Route>

    <Route path="lessonReport/">
      <Route path="template/">
        <Route path="list" element={<LessonReportTemplateList />} />
        <Route path="add" element={<LessonReportTemplateAdd />} />
      </Route>
      <Route path="group/">
        <Route path="list" element={<LessonReportGroupList />} />
        <Route path="add" element={<LessonReportGroupAdd />} />
        <Route path="write" element={<LessonReportGroupWrite />} />
      </Route>
    </Route>
    <Route path="exam/">
      <Route path="template/">
        <Route path="list" element={<ExamTemplateList />} />
        <Route path="add" element={<ExamTemplateAdd />} />
      </Route>
      <Route path="group/">
        <Route path="list" element={<ExamGroupList />} />
        <Route path="add" element={<ExamGroupAdd />} />
        <Route path="write" element={<ExamGroupWrite />} />
      </Route>
      <Route path="simpleExam" element={<SimpleExam />} />
    </Route>
    <Route path="analysisReport/">
      <Route path="generate" element={<AnalysisReportGenerate />} />
    </Route>

    <Route path="counsel/">
      <Route path="log" element={<CounselLog />} />
      <Route path="logCount" element={<CounselLogCount />} />
    </Route>

    <Route path="message/">
      <Route path="send" element={<MessageSend />} />
      <Route path="history" element={<MessageHistory />} />
    </Route>

    <Route path="setting/">
      <Route index element={<SettingAttendance />} />
      <Route path="academyInfo" element={<SettingAcademyInfo />} />
      <Route path="billingPlan" element={<SettingBillingPlan />} />
      <Route path="billingPlan/features" element={<SettingBillingFeatureStatus />} />
      <Route path="billingPlan/trialApply" element={<SettingBillingTrialApply />} />
      <Route path="billingPlan/plusApply" element={<SettingBillingPlusApply />} />
      <Route path="billingPlan/plusEnd" element={<SettingBillingPlusEnd />} />
      <Route path="billingPlan/billingInfoEdit" element={<SettingBillingInfoEdit />} />
      <Route path="academyManagement" element={<SettingAcademyManagement />} />
      <Route path="attendance" element={<SettingAttendance />} />
      <Route path="billSetting" element={<SettingBill />} />
      <Route path="message" element={<SettingMessage />} />
      <Route path="contentPoint" element={<SettingContentPoint />} />
      <Route path="post" element={<SettingPost />} />
      <Route path="chat" element={<SettingChat />} />
      <Route path="homework" element={<SettingHomework />} />
      <Route path="textbook" element={<SettingTextbook />} />
    </Route>
  </Route>
);

export default RouteListTeacherSide;
